import Message from "../../message";
import {useMainStore} from "@/store";
import {cleanupStaleNotifications} from "@/services/notificationCleanup";

export default class InviteRevoked extends Message
{
    handle()
    {
        useMainStore().REMOVE_INVITE(this.message.guild_id);
        cleanupStaleNotifications();
    }
}
